/**
 * @generated SignedSource<<cfdb3d91be90627cbb5793f4dcc3be8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CallWidgetHost_employee$data = {
  readonly currentCall: {
    readonly " $fragmentSpreads": FragmentRefs<"CallWidget_call">;
  } | null | undefined;
  readonly " $fragmentType": "CallWidgetHost_employee";
};
export type CallWidgetHost_employee$key = {
  readonly " $data"?: CallWidgetHost_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"CallWidgetHost_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CallWidgetHost_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Call",
      "kind": "LinkedField",
      "name": "currentCall",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CallWidget_call"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "fe0bdb794bf87d4c51831a7cfc619838";

export default node;
